import { createAsyncThunk, createSlice, isAnyOf } from "@reduxjs/toolkit";
import { cartApi } from "../../cart/api/cartApi.js";
import { offerApi } from "../../offer/api/offerApi.js";
import { wishlistApi } from "../api/wishlistApi.js";

export const moveWishlistItemToCart = createAsyncThunk(
  "wishlistApi/moveToCart",
  async (item, { dispatch, fulfillWithValue, rejectWithValue }) => {
    const { id, qty, companionemail } = item;

    try {
      await dispatch(
        cartApi.endpoints.addCartItem.initiate({
          products: [{ id, qty }],
        }),
      ).unwrap();

      await dispatch(
        wishlistApi.endpoints.removeWishlistItem.initiate({
          productid: id,
          companionemail,
        }),
      ).unwrap();
      return fulfillWithValue(true);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

const initialState = {
  isCompanion: false,
  ActiveCompanion: null,
  isLoading: false,
  showPopup: false,
};

export const wishlistSlice = createSlice({
  name: "wishlist",
  initialState,
  reducers: {
    setShowPopup: (state, { payload }) => {
      state.showPopup = payload;
    },
  },
  extraReducers: (builder) => {
    const { getOffer } = offerApi.endpoints;
    const { getWishlistItems } = wishlistApi.endpoints;

    builder
      .addMatcher(
        isAnyOf(
          getWishlistItems.matchFulfilled,
          moveWishlistItemToCart.fulfilled,
          getWishlistItems.matchRejected,
          moveWishlistItemToCart.rejected,
        ),
        (state, _action) => {
          state.isLoading = false;
        },
      )
      .addMatcher(
        isAnyOf(getWishlistItems.matchPending, moveWishlistItemToCart.pending),
        (state, _action) => {
          state.isLoading = true;
        },
      )
      .addMatcher(getOffer.matchFulfilled, (state, { payload }) => {
        const { Companions } = payload;

        const companionId = new URLSearchParams(window.location.search)?.get(
          "c",
        );

        if (!companionId) {
          state.isCompanion = false;
        } else if (Companions.length > 0) {
          const companion = Companions.find(
            ({ CompanionID }) => String(CompanionID) === companionId,
          );
          state.isCompanion = true;
          state.ActiveCompanion = companion;
        }
      });
  },
});

export const { setShowPopup } = wishlistSlice.actions;

export const getWishlist = (state) => state.wishlist;
export const getShowPopup = (state) => state.wishlist.showPopup;

export default wishlistSlice.reducer;
